import "./TemplateList.css";

import {
	CircularProgress,
	Grid,
	Icon,
	Menu,
	MenuItem,
	Tooltip,
} from "../../common/MaterialComponent";
import React, { useEffect } from "react";

import { ButtonPrimary } from "../../common/sharedStyle";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import { GetMyTemplates } from "../../api/batchNotificationController";
import { PreSubmissionConfigurationModel } from "../../models/BatchMessage/BatchMessageDetailModel";
import { TemplateListDataGrid } from "../TemplateListDataGrid/TemplateListDataGrid";
import { TemplateType } from "../../common/enum";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";
import { useHistory } from "react-router-dom";

export const TemplateList: React.FC = () => {
	const [error, setError] = React.useState<string>("");
	const [templateList, setTemplateList] = React.useState<
		PreSubmissionConfigurationModel[]
	>([]);
	const [updateRequired, setUpdateRequired] = React.useState<boolean>(true);

	const [mounted, setMounted] = React.useState<boolean>(false);
	const strings = useGetComponentStringsContext().TemplateList;
	const history = useHistory();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const templateTypeOptions = [
		{
			key: TemplateType[TemplateType.BatchMessaging],
			value: strings.batchMessagingOption,
		},
		// {
		// 	key: TemplateType[TemplateType.RequestForHelp],
		// 	value: strings.requestForHelpOption,
		// },
	];

	useEffect(() => {
		const getMyTemplates = async () => {
			try {
				const res = await GetMyTemplates();
				if (res.error) {
					setError(res.error);
				} else {
					setTemplateList(res.responseObj ? res.responseObj : []);
					setMounted(true);
					setUpdateRequired(false);
				}
			} catch (err) {
				setError(err);
			}
		};

		if (updateRequired) {
			setTimeout(() => {
				getMyTemplates();
			}, 1000);
		}
	}, [updateRequired]);

	const onNotificationIdChange = (
		preSubmissionConfigurationDetail: PreSubmissionConfigurationModel
	) => {
		const pathName =
			preSubmissionConfigurationDetail.type ===
			TemplateType[TemplateType.BatchMessaging]
				? "/batchMessageConfiguration/"
				: "/requestForHelpConfiguration/";
		history.push({
			pathname:
				pathName +
				preSubmissionConfigurationDetail.partitionKey +
				"/" +
				preSubmissionConfigurationDetail.id,
			state: {
				requestFromPath: "templateList",
			},
		});
	};

	const addNewTemplate = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleTemplateTypeSelection = (
		event: React.MouseEvent<HTMLElement>,
		index: number
	) => {
		const pathName =
			templateTypeOptions[index].key ===
			TemplateType[TemplateType.BatchMessaging]
				? "/batchMessageConfiguration"
				: "/requestForHelpConfiguration";
		history.push({
			pathname: pathName,
			state: {
				requestFromPath: "templateList",
			},
		});
		setAnchorEl(null);
	};

	return (
		<div>
			{error ? (
				<ErrorPage message={strings.templateListErrorMessage} />
			) : !mounted ? (
				<div className="loader">
					<CircularProgress size={50} />
				</div>
			) : (
				<>
					<Grid container spacing={3} data-testid="templateContainer">
						<Grid item xs={12}>
							<div
								className="addTemplateBtnDiv"
								data-testid="addTemplateButton"
							>
								<Tooltip title={strings.addTemplateBtnTooltip}>
									<ButtonPrimary
										data-testid="addTemplate"
										onClick={addNewTemplate}
										className="addTemplateBtn"
									>
										<Icon>add</Icon>
									</ButtonPrimary>
								</Tooltip>
							</div>
						</Grid>
						<Grid item xs={12}>
							<TemplateListDataGrid
								templateList={templateList}
								displayStatusColumn={true}
								scheduledTemplate={false}
								title={strings.title}
								onNotificationIdChange={(
									model: PreSubmissionConfigurationModel
								) => onNotificationIdChange(model)}
								onApproveTemplateSelectedId={() => {}}
								onRejectTemplateSelectedId={() => {}}
								messageCancelEnabled={false}
								templateUpdateRequired={setUpdateRequired}
								setMounted={setMounted}
							/>
						</Grid>
					</Grid>
					<Menu
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						getContentAnchorEl={null}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "left",
						}}
						onClose={() => {
							setAnchorEl(null);
						}}
						data-testid="templateTypeList"
					>
						{templateTypeOptions.map((option, index) => (
							<MenuItem
								key={index}
								onClick={(event) => handleTemplateTypeSelection(event, index)}
								data-testid="templateTypeListItem"
							>
								{option.value}
							</MenuItem>
						))}
					</Menu>
				</>
			)}
		</div>
	);
};
